<template>
    <div class="text-center">
        <h1 class="text-center my-5" :class="[5, 6].includes(status) ? 'text-warning' : 'text-success'">
            <v-icon v-if="[5, 6].includes(status)" size="large" class="text-warning">mdi-exclamation-thick</v-icon>
            <v-icon v-else size="large" class="text-success">mdi-checkbox-marked-circle-outline</v-icon>
            <span v-if="status === 6 && !isTO1">{{ $t(`bookingStatus.${getBookingStatusLocaleKey(0)}`) }}</span>
            <span v-else>{{ $t(`bookingStatus.${getBookingStatusLocaleKey(status)}`) }}</span>
        </h1>
        <template v-if="status === 6 && !isTO1">
            <div>
                <strong>{{ $t('thanks_for_your_booking') }}</strong>
            </div>
            <div>
                <strong class="text-warning">{{ $t('order_need_manual_processing') }}</strong>
            </div>
        </template>
        <template v-else-if="errors && errors.length">
            <div v-for="(error, errorIndex) in errors" :key="errorIndex">
                <strong class="text-warning" v-html="parseErrorMessage(error.message)" />
            </div>
        </template>
        <p>
            {{ $t('your_booking_number') }} <strong data-cy="reservation-number">{{ orderId }}</strong>
        </p>
        <p v-if="personEmail">
            {{ status !== 10 ? $t('booking_details_sent_to') : $t('quote_details_sent_to') }}
            <strong>{{ personEmail }}</strong>
        </p>
        <p>
            {{ $t('confirm_questions') }}
            <span v-if="company.emails && company.emails.length">
                <span class="font-weight-bold">{{ company.emails[0] }}</span>
                <span v-if="company.phones && company.phones.length">
                    {{ $t('or') }}
                </span>
            </span>
            <span v-if="company.phones && company.phones.length" class="font-weight-bold">{{
                company.phones.join(',')
            }}</span>
        </p>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class ConfirmationStatus extends Vue {
        @Prop({default: () => ({phones: []})}) company
        @Prop() tourlead

        unmounted() {
            persistentStore.SET_TOURISTS([])
            hotelsStore.SET_TOURISTS([])
            transfersStore.RESET()
        }

        parseErrorMessage(message) {
            if (message.indexOf('Extra seats were not added to booking') !== -1) {
                let message = this.$t('flights.warnings.seats_no_added')
                if (!this.isTO1) {
                    message += ' ' + this.$t('flights.warnings.please_contact_your_manager')
                }
                return message
            }
            if (message.indexOf('Extra services were not added to booking') !== -1) {
                let message = this.$t('flights.warnings.extra_services_no_added')
                if (!this.isTO1) {
                    message += ' ' + this.$t('flights.warnings.please_contact_your_manager')
                }
                return message
            }
            return message
        }

        getBookingStatusLocaleKey(status) {
            return [
                'CONFIRMATION_PENDING',
                'CONFIRMATION_PENDING',
                'CONFIRMED',
                'CANCELLATION_PENDING',
                'CANCELED',
                'REJECTED',
                'ERROR',
                'CANCELLATION_REJECTED',
                'ON_CONFIRM',
                'CANCELED_WITHOUT_FEE',
                'QUOTED',
                'ISSUED',
                'ESTIMATED',
                'TICKET_ISSUING',
                'NO_SHOW',
                'PRE_CONFIRMED',
            ][status]
        }

        get personEmail() {
            return this.tourlead
                ? this.tourlead.email
                : authStore.person
                  ? authStore.person.email
                  : authStore.registeredPerson
                    ? authStore.registeredPerson.email
                    : null
        }

        get orderId() {
            return persistentStore.bookResponse[0].orderId
        }

        get status() {
            if (persistentStore.bookResponse.length > 1) {
                const errorIndex = persistentStore.bookResponse.findIndex(entry => entry.status === '6')
                if (errorIndex >= 0) return parseInt(persistentStore.bookResponse[errorIndex].status, 10)

                const index = persistentStore.bookResponse.findIndex(
                    entry => entry.status === '0' || entry.status === '1'
                )
                if (index >= 0) return parseInt(persistentStore.bookResponse[index].status, 10)
            }
            return parseInt(persistentStore.bookResponse[0].status, 10)
        }

        get errors() {
            return persistentStore.bookResponse[0].errors
        }

        get isTO1() {
            return authStore.isTO1
        }
    }

    export default ConfirmationStatus
</script>
